// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbItemText_container__aZi2G"};